import { Loader2 } from 'lucide-react'

export default function FullScreenSpinner() {
  return (
    <div className="min-h-[100svh] flex items-center justify-center bg-bg-canvas">
      <Loader2 className="h-6 w-6 text-brand-accent animate-spin" aria-label="Ładowanie" />
    </div>
  )
}
